import { Button } from "@mui/material";
import MyDialog from "../../Generico/MyDialog";

const HelperTokenPicpay = ({ picPayHelpDialog, onClose }) => {
  return (
    <MyDialog
      isOpen={picPayHelpDialog}
      title="Como conseguir seu token do PicPay"
      handleClose={onClose}
      dialogActions={<Button onClick={onClose}>Fechar</Button>}
    >
      <h3>Passo 1</h3>
      <p>
        Criar sua conta de e-comerce no PicPay:
        <a
          target="_blank"
          href="https://ecommerce.picpay.com/"
          rel="noreferrer"
        >
          clicando aqui
        </a>
      </p>

      <h3>Passo 2</h3>
      <p>
        Após sua conta criada, acesse: <strong>Integrações</strong> no menu
        principal do PicPay
      </p>

      <h3>Passo 3</h3>
      <p>
        Na aba 'Integrações', busque por <strong>x-picpay-token</strong> e copie
      </p>

      <h3>Passo 4</h3>
      <p>Cole o Token no qrpedir</p>
    </MyDialog>
  );
};

export default HelperTokenPicpay;
